import { render, staticRenderFns } from "./RedirectFormItems.vue?vue&type=template&id=613a48e4&"
import script from "./RedirectFormItems.vue?vue&type=script&lang=js&"
export * from "./RedirectFormItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports